import React, { useCallback } from "react";
import { Delete } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { SelectWithSearch, SelectWithSearchOption } from "../SelectWithSearch/SelectWithSearch";

export const ConnectToEntitiesInput = (props: ConnectToEntitiesInputProps) => {
  const { onChange, value, options, selectLabel = "Add to entity" } = props;

  const valuesAsOptions = value
    .split(",")
    .filter((string) => string)
    .map((v) => ({ value: v, label: options.find((o) => o.value === v)?.label || "" }));

  const handleRemove = useCallback(
    (valueToRemove: string) => {
      onChange(valueToRemove, true);
    },
    [onChange]
  );

  const handleAdd = useCallback(
    (valueToAdd: string) => {
      onChange(valueToAdd, false);
    },
    [onChange]
  );

  return (
    <div className="_d-grid">
      {valuesAsOptions.map((option, index) => (
        <div className="module-connected-to-entity" key={index}>
          {option.label}
          <IconButton onClick={() => handleRemove(option.value)}>
            <Delete />
          </IconButton>
        </div>
      ))}
      <SelectWithSearch
        options={options
          .filter((o) => !value.split(",").includes(o.value))
          .map((o) => ({ name: o.label, id: o.value }))}
        onChange={(options: SelectWithSearchOption[]) => handleAdd(String(options[0].id))}
        value={null}
        label={selectLabel}
      />
    </div>
  );
};

interface ConnectToEntitiesInputProps {
  onChange: (value: string, isRemove?: boolean) => void;
  value: string;
  options: { label: string; value: string }[];
  selectLabel?: string;
}
